import React from 'react'

import {BottomSheet} from '@daedalus/atlas/BottomSheet'
import {useDeviceLayout} from '@daedalus/atlas/context/deviceLayout'
import {Box} from '@daedalus/atlas/helpers/Box'
import {PopUp} from '@daedalus/atlas/PopUp'
import {Text} from '@daedalus/atlas/Text'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

const TitleContent = () => (
  <FormattedMessageWrapper
    id="priceDifferenceAlert.updateTitle"
    defaultMessage="Why has the price changed?"
  />
)

const BodyContent = () => (
  <Box paddingTop="s300" desktopXs={{paddingTop: 's500'}}>
    <Text variant="bodyM">
      <FormattedMessageWrapper
        id="priceDifferenceAlert.updateDescription"
        defaultMessage="Hotels change their prices frequently based on demand. We always show you the latest available prices, which means they can sometimes change after you make a selection."
      />
    </Text>
  </Box>
)

interface Props {
  onClose: () => void
  isOpen: boolean
}
export const PriceDifferenceReason: React.FC<Props> = ({onClose, isOpen}) => {
  const {isMobile} = useDeviceLayout()

  if (isMobile) {
    return (
      <BottomSheet
        isOpen={isOpen}
        onClose={onClose}
        titleBarProps={{
          centerContent: <TitleContent />
        }}
      >
        <BodyContent />
      </BottomSheet>
    )
  }
  return (
    <PopUp
      isOpen={isOpen}
      titleBarProps={{centerContent: <TitleContent />, hasDivider: true}}
      closeAction={onClose}
    >
      <BodyContent />
    </PopUp>
  )
}
